import { h } from 'preact'
import { TFunctionDetailedResult } from 'i18next'

import InfoTooltip from './info-tooltip'

interface SummaryRowProps {
  label: TFunctionDetailedResult
  value: string
  isBold?: boolean
  tooltipText?: string
}

const SummaryRow = ({ label, value, isBold, tooltipText }: SummaryRowProps) => (
  <div className="transfer-calculator__summary-row">
    <p className="transfer-calculator__summary-text transfer-calculator__summary-text--name">
      {isBold ? <b>{label}</b> : label}
      {tooltipText && <InfoTooltip text={tooltipText} />}
    </p>
    <p className="transfer-calculator__summary-text transfer-calculator__summary-text--value">
      {isBold ? <b>{value}</b> : value}
    </p>
  </div>
)

export default SummaryRow
